import { useState } from 'react'
import type { NodeType } from '../api/scada'
import { DeviceDetailModal } from '../components/DeviceDetailModal'

// The {openDevice, setOpenDevice} state + conditional-render block was
// duplicated identically in ScadaView.tsx and InfrastructureFocus.tsx
// (docs/plan-web-ux-cohesion.md, Phase 4) -- each has multiple trigger call
// sites (PumpCard/ReservoirCard's "Detalji" links; DemandsAttentionSection's
// tiles and TopologyView's map, both funneling into InfrastructureFocus.tsx's
// one instance) feeding one shared piece of state. Returns the rendered
// element rather than just the state, since the JSX invoking
// DeviceDetailModal was the actual duplicated part, not just the useState
// line.
export function useDeviceDetailModal() {
  const [openDevice, setOpenDevice] = useState<{ deviceKey: string; nodeType: NodeType } | null>(null)

  return {
    openDeviceDetail: (deviceKey: string, nodeType: NodeType) => setOpenDevice({ deviceKey, nodeType }),
    deviceDetailModal: openDevice && (
      <DeviceDetailModal
        deviceKey={openDevice.deviceKey}
        nodeType={openDevice.nodeType}
        onClose={() => setOpenDevice(null)}
      />
    ),
  }
}
